$(document).ready(function(){

//   //   Hide Option of sold variants 

//   $('.collection-product-variants-select  option').each(function() {
//     if($(this).data('available') === 'no'){
//       $(this).parents('.product-form').find('.collection-options-select').children('option[data-value="'+$(this).data('title')+'"]').attr('disabled','true');
//       $(this).parents('.product-form').find('.collection-options-select').children('option[data-value="'+$(this).data('title')+'"]').attr('hidden','true');
//     }
//   });

//   //   On Mobile View - Disbabled Zoom on Product Page Images
//   var window_width = $( window ).width();
//   if(window_width < 500){
//     $('body').find('.product-main-image').removeClass('zoom-active');
//     setTimeout(function(){
//       $('body').find('.product-main-image').removeClass('zoom-enabled');
//     },500);
//   }

//   // Product Page JS

//   $('.rc_popup__hover').click(function(e){

//     $(this).find('.rc_popup__block').toggle();
//   });

//   $('.rc_popup__hover').mouseleave(function(e){
//     e.preventDefault();
//     $('.rc_popup__block').css('display','none');

//   });


//   $('.p-option').click(function(){
//     $('.p-option').removeClass('p-selected');
//     $(this).addClass('p-selected');
//     var compare = parseFloat($(this).find('.o-compare-at-price').data('value'));
//     var price = parseFloat($(this).find('.o-price').data('value'));
//     console.log(price,compare,Math.ceil(100 - (price/compare * 100)));

//     var save = Math.ceil(100 - (price/compare * 100));
//     if($(this).find('.o-compare-at-price').data('show') === 'yes'){
//       $('.save-money-competitor').find('.save-money').text("Save "+save+"%");
//       $('.save-money-competitor').show();
//     }
//     else{
//       $('.save-money-competitor').hide();
//     }

//     $(this).closest('form').find('.product-select').val($(this).closest('form').find('.product-select').children('option[data-title="'+$(this).data('title')+'"]').val()).change();

//     if($(this).data('image') !== ''){
//       $('.product-thumbnails').find('img[data-image-id='+$(this).data('image')+']').trigger('click');
//       if($(this).hasClass("sold-out")){
//         $('.product-image-wrapper').addClass("out-of-stock");
//         $('.product-main-image').addClass("compromise-padding");
//         $('.product-quantity').hide();
//         $('.product-submit').hide();
//       }
//       else{
//         $('.product-image-wrapper').removeClass("out-of-stock");
//         $('.product-main-image').removeClass("compromise-padding");
//         $('.product-quantity').show();
//         $('.product-submit').show();
//       }

//     }

//     var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant='+$(this).data('variant');    
//     window.history.pushState({ path: refresh }, '', refresh);
//   });

//   if($('.p-option').hasClass('p-selected')){
//     var $this = $('.p-option.p-selected'); 
//     var compare = parseFloat($this.find('.o-compare-at-price').data('value'));
//     var price = parseFloat($this.find('.o-price').data('value'));
//     console.log(price,compare,price/compare * 100);

//     var save = Math.ceil(100 - (price/compare * 100));

//     if($this.find('.o-compare-at-price').data('show') === 'yes'){
//       $('.save-money-competitor').find('.save-money').text("Save "+save+"%");
//       $('.save-money-competitor').show();
//     }
//     else{
//       $('.save-money-competitor').hide();
//     }
//     //     $('.save-money-competitor').find('.save-money').text("Save "+save+"%");

//     $this.closest('form').find('.product-select').val($this.closest('form').find('.product-select').children('option[data-title="'+$this.data('title')+'"]').val()).change();
//     if($this.data('image') !== ''){
//       $('.product-thumbnails').find('img[data-image-id='+$this.data('image')+']').trigger('click');
//       if($this.hasClass("sold-out")){
//         $('.product-image-wrapper').addClass("out-of-stock");
//         $('.product-main-image').addClass("compromise-padding");
//         $('.product-quantity').hide();
//         $('.product-submit').hide();
//       }
//       else{
//         $('.product-image-wrapper').removeClass("out-of-stock");
//         $('.product-main-image').removeClass("compromise-padding");
//         $('.product-quantity').show();
//         $('.product-submit').show();
//       }

//     }
//   }


//   $('.buy-now-button').click(function(){
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: $(this).closest('form').serialize(),
//       dataType: 'json',
//       success:function(){
//         window.location.href = '/checkout';
//       },
//     });
//   });


//   var total_slides = $('.product-thumbnails img').length;
//   var active_slide = 1;
//   $('.arrow-left').click(function(){

//     if(active_slide == 1 ){
//       $('.product-thumbnails img:nth-child('+active_slide+')').trigger('click');

//       active_slide = total_slides;
//     }
//     else{
//       active_slide = active_slide - 1;
//       $('.product-thumbnails img:nth-child('+active_slide+')').trigger('click');
//     }



//   });

//   $('.arrow-right').click(function(){

//     if(active_slide == total_slides){
//       $('.product-thumbnails img:nth-child('+active_slide+')').trigger('click');
//       active_slide = 1;
//     }
//     else{
//       active_slide = active_slide + 1;
//       $('.product-thumbnails img:nth-child('+active_slide+')').trigger('click');
//     }

//   });
//   //   End Product Page JS
//   $('.js-ajax-cart-overlay').click(function(){
//     $('.js-ajax-cart-drawer-close').trigger('click');

//   });

//   rerender_section();
//   bogo_message();

//   $('.custom_cart_drawer_ajax .Cart__NoteButton').click(function(){
//     $(this).addClass('is-hide');
//     $('.custom_cart_drawer_ajax .Cart__OffscreenNoteContainer').addClass("is-open");
//     bogo_message();
//   });

//   $('.custom_cart_drawer_ajax .js-ajax-cart-drawer-close').click(function(){
//     $('.custom_cart_drawer_ajax').removeClass('drawer-is-open');
//     $('.custom_cart_drawer_ajax .js-ajax-cart-drawer,.cstm_ajx').removeClass('is-open');
//     bogo_message();
//   });

//   $('.header-tools-cart').click(function(event){
//     event.preventDefault();
//     $('.custom_cart_drawer_ajax').addClass('drawer-is-open');
//     $('.custom_cart_drawer_ajax .js-ajax-cart-drawer,.cstm_ajx').addClass("is-open");
//     bogo_message();
//   });


//   update_cart_new();




//   $('.custom_cart_drawer_ajax').on('change' , '.cart__qty-input', function(){

//     jQuery.post('/cart/change.js', { quantity : $(this).val(), id: $(this).attr('id') });
//     update_cart_new();
//     rerender_section();
//     bogo_message();
//   });  

//   $('.custom_cart_drawer_ajax').on('click','.inc',function(){
//     var _id = $(this).prev("input").attr("id");
//     var val = +$(this).prev("input").attr("value")+1;
//     jQuery.post('/cart/change.js', { quantity : val, id:_id });

//     setTimeout(function(){
//       update_cart_new();
//       rerender_section();
//       bogo_message();
//     },800)
//   });

//   $('.custom_cart_drawer_ajax').on('click',' .dec',function(){
//     var _id = $(this).next("input").attr("id");
//     var val = $(this).next("input").attr("value");
//     val = val - 1;
//     jQuery.post('/cart/change.js', { quantity : val, id:_id });

//     setTimeout(function(){
//       update_cart_new();
//       rerender_section();
//     },800)
//   });


//   $('.custom_cart_drawer_ajax .Button--save').click(function(){
//     var zs = $('.custom_cart_drawer_ajax .Cart__Note.Form__Textarea').val();
//     jQuery.post('/cart/update.js',{note: zs});

//   });

//   $('.add-to-cart').click(function(event){
//     event.preventDefault();
//     var km = $(this).closest('form').attr("data-productid");
//     jQuery.post('/cart/add.js', $(this).closest('form').serialize());

//     setTimeout(function(){
//       update_cart_new();
//       $('.custom_cart_drawer_ajax').addClass('drawer-is-open');
//       $('.custom_cart_drawer_ajax .js-ajax-cart-drawer,.cstm_ajx').addClass("is-open");
//       rerender_section();
//       bogo_message();

//     },500);

//   });

//   $('.single-option-selector').change(function(){
//     $(this).closest('form').find('.product-select').val($(this).closest('form').find('.product-select').children('option[data-title="'+$(this).val()+'"]').val()).change();
//   });



//   $(document).on("click",'.product-form__cart-submit',function(event){
//     event.preventDefault();
//       setTimeout(function(){
//         addFreeItemSubs();
//       },500);
//   });


// $(document).on("change",".cart__qty-input",function(event){
//   var vid = $(this).closest("tr").attr("data-cart-item-key").split(":")[0];
//   var sp = "";
//   sp = $(this).closest("tr").find(".product-details__item.product-details__item--property").text();
//   if($(this).val() == 0 && sp != ""){
//     setTimeout(function(){addFreeItemSubs();},800)
//   }
// })


})



// function update_cart_new(gift=0)
// {
//   setTimeout(function(){
//     jQuery.getJSON('/cart.js', function(cart) {

//       let items_new = cart.items;
//       if(items_new.length>=1){
//         $('.js-ajax-cart-drawer-content .mrow').remove();
//         $('.js-ajax-cart-drawer-content .cart-body').text('');

//         for(var i=0; i < items_new.length; i++)
//         {
//           var title_new = items_new[i].title.split("-")[0];
//           var options = items_new[i].options_with_values;
//           if(items_new[i].discounts.length > 0){
//             $('.custom_cart_drawer_ajax .js-ajax-cart-drawer-content .cart-body').append('<tr class="mrow"><td class="crow c-image"> <img class="cimage"  src="'+ items_new[i].image +'"></td><td class="c-d"><a class="ctitle" href="'+ items_new[i].url+' ">'+ title_new +'</a><p class="opt_values">'+options[0].value+'</p><div class="cquantity" ><span class="dec inc-dec">-</span><input class="cart__qty-input custom_ajax_cart" type="number" min="0" pattern="[0-9]*" value='+ items_new[i].quantity +' id='+ items_new[i].id +'><span class="inc inc-dec">+</span></div><p id="rmv" class="remove" onclick="removeItem('+items_new[i].id+')" value="'+items_new[i].id+'">Remove</p></td><td class="cfprice money price" data-open-accessibility-text-original="15px" style="font-size: 15px;"><s class="original-price"><span class="money" data-open-accessibility-text-original="18px" style="font-size: 18px;display:block">'+ Shopify.formatMoney(items_new[i].original_price) +'</span></s><span class="final-price money" data-open-accessibility-text-original="18px" style="font-size: 18px;"><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" style="display: none !important; font-size: 18px;" data-open-accessibility-text-original="18px"></span>'+ Shopify.formatMoney(items_new[i].final_line_price) +'</span><ul class="cart-item-discounts"><li data-open-accessibility-text-original="13.125px" style="font-size: 13.125px;">'+ items_new[i].discounts[0].title +'(-<span class="money" data-open-accessibility-text-original="18px" style="font-size: 18px;">'+Shopify.formatMoney(items_new[i].discounts[0].amount) +'</span>)</li></ul></td><tr>');

//           }
//           else{
//             $('.custom_cart_drawer_ajax .js-ajax-cart-drawer-content .cart-body').append('<tr class="mrow"><td class="crow c-image"> <img class="cimage"  src="'+ items_new[i].image +'"></td><td class="c-d"><a class="ctitle" href="'+ items_new[i].url+' ">'+ title_new +'</a><p class="opt_values">'+options[0].value+'</p><div class="cquantity" ><span class="dec inc-dec">-</span><input class="cart__qty-input custom_ajax_cart" type="number" min="0" pattern="[0-9]*" value='+ items_new[i].quantity +' id='+ items_new[i].id +'><span class="inc inc-dec">+</span></div><p id="rmv" class="remove" onclick="removeItem('+items_new[i].id+')" value="'+items_new[i].id+'">Remove</p></td><td class="cfprice money price" >'+ Shopify.formatMoney(items_new[i].final_line_price) +'</td><tr>');

//           }
//         }
//         if(cart.note != '')
//         {
//           $('.custom_cart_drawer_ajax .Cart__Note.Form__Textarea').val(cart.note);
//         }

//       }else
//       {
//         $('.mrow').remove();
//         $('.js-ajax-cart-drawer-content .cart-body').text('Cart is empty');
//         $('.custom_cart_drawer_ajax .Cart__Note.Form__Textarea').val('');
//       }
//       console.log("Total: ",Shopify.formatMoney(cart.total_price));
//     })
//     if(gift === 0){
//       update_gift();
//     }
//   },300);
// }


// function removeItem(id)
// {
//   console.log("fun ",id);
//   jQuery.post('/cart/change.js', { quantity: 0, id: id });
//   update_cart_new();
//   rerender_section();
//   bogo_message();
// }

// function rerender_section(){
//   $.ajax({
//     url: '/?section_id=re-render',
//     method : 'get',
//     success:function(request){
//       console.log(request,'ok');
//       $('#rerender-div').empty();
//       $('#rerender-div').append(request);
//     },

//   });
//   bogo_message(); 
// }

// function bogo_message(){
//   jQuery.getJSON('/cart.js', function(cart) {
//     if(cart.item_count === 0){
//       $('.cart-item-count').text('');
//       $('.cart-item-count').hide();

//     }
//     else{
//       $('.cart-item-count').text(cart.item_count);
//       $('.cart-item-count').show();

//     }



//     if(cart.item_count === 1){
//       $('.bogo-message').show();
//     }
//     else{
//       $('.bogo-message').show();
//     }

//   });
// }


// function update_gift(){

//   jQuery.getJSON('/cart.js', function(cart) {
//     // for items in cart    
//     let items_new = cart.items;
//     // for identify if the cart already has gift
//     let already_exist_gift = 0;

//     let total_without_gift = 0;

//     let free_gift = '32194637561988';

//     let gift_product_quantity = 0;

//     let any_subsribed_variant = 0;


//     for(var i=0; i < items_new.length; i++)
//     {
//       if(items_new[i].variant_id === 32194637561988){
//         if(items_new[i].total_discount === items_new[i].original_price){
//           already_exist_gift = already_exist_gift + 1;

//         }
//         else{
//           total_without_gift = total_without_gift + items_new[i].line_price;
//         }

//         gift_product_quantity = gift_product_quantity + items_new[i].quantity;
//       }


//       else{
//         total_without_gift = total_without_gift + items_new[i].line_price;
//       }

//       //       console.log(items_new[i].properties);
//       if(items_new[i].properties != undefined || items_new[i].properties != null ){

//         if("shipping_interval_unit_type" in items_new[i].properties) {
//           any_subsribed_variant = any_subsribed_variant + 1;
//         }

//       }
//     }

//     console.log(any_subsribed_variant);
//     if(any_subsribed_variant > 0){
//       remove_gift(free_gift,gift_product_quantity);
//     }
//     else{
//       if( total_without_gift >= 499){
//         if(already_exist_gift === 0) {
//           if(any_subsribed_variant === 0){
//             add_gift(free_gift);
//           }

//         }
//         else if(already_exist_gift > 0){
//           if(any_subsribed_variant > 0){
//             remove_gift(free_gift,gift_product_quantity);
//           }
//           else{
//             //      Lotion Gift Already there and Total without gift is above 4.99$.
//           }
//         }

//       }
//     }

//   });
//   // update drawer cart.
//   update_cart_new(1);
// }


// function add_gift(gift_id){
//   jQuery.post('/cart/add.js', {
//     items: [
//       {
//         quantity: 1,
//         id: gift_id
//       }
//     ]
//   });
//   // update_cart_new(1);
// }


// function remove_gift(gift_id,gift_product_quantity){
//   // let quantity = gift_product_quantity - 1;
//   jQuery.post('/cart/change.js', { quantity: 0 , id: gift_id });
//   // update_cart_new(1);
//   // rerender_section();
//   // bogo_message();
// }



function addCartItem(id){
	jQuery.post('/cart/add.js', {quantity:1,id:id});
}

function removeCartItem(id)
{
  jQuery.post('/cart/change.js', { quantity: 0, id: id });
  if(window.location.href.indexOf("/cart")>-1){
    setTimeout(function(){window.location.reload();},600)
  }
}

function addFreeItemSubs()
{
    jQuery.getJSON('/cart.js', function(cart) {
      let items_new = cart.items;
      var check_subs = false, check_item=true;
        for(var i=0; i < items_new.length; i++)
        {
          if(items_new[i].variant_id && items_new[i].variant_id == "40762519814276"){
            check_item = false;
          }
          if(items_new[i].selling_plan_allocation && items_new[i].selling_plan_allocation.selling_plan){
          	check_subs =true;
          }
        }
        
        if(check_subs && check_item){
          addCartItem(40762519814276);
     	}
        // console.log(check_subs, " check_item ",check_item);
        if(check_subs==false && check_item==false){
        	removeCartItem('40762519814276');
        }
    })
}

function update_cart()
{
  setTimeout(function(){
    jQuery.getJSON('/cart.js', function(cart) {
      let items_new = cart.items;
      if(items_new.length>=1){
        for(var i=0; i < 1; i++)
        {
          var title_new = items_new[i].product_title;
          var options = items_new[i].options_with_values.length>0?items_new[i].options_with_values[0]:"";
          var subsc = items_new[i].selling_plan_allocation!=undefined ?items_new[i].selling_plan_allocation.selling_plan.name:"";
          $(".cart-popup-item__image-wrapper").html('<img src="'+items_new[i].image+'" class="cart-popup-item__image" data-cart-popup-image="" be_marvel="1">');
          $(".cart-popup-item__title").text(title_new);
          $(".cart-popup-item__description .product-details").html('<li class="product-details__item product-details__item--variant-option">'+options!=""&&options.name+': '+options!=""&&options.value+'</li><li class="product-details__item product-details__item--property">'+subsc+'</li>');
          $(".cart-popup-item__quantity span[data-cart-popup-quantity]").text(items_new[i].quantity);
        }
      }

    })
  },600);
}





